import { Button } from "@heroui/react";
import { Plural, Trans } from "@lingui/react/macro";
import { useState } from "react";
import { useNavigate } from "react-router";
import { useShallow } from "zustand/react/shallow";
import { LimeAlert } from "@/Components/NextBase/LimeAlert";
import { api } from "@/lib/api-client";
import useUserPermissionsStore from "@/stores/useUserPermissionsStore";

/**
 * Nudges a Croatian salon to confirm the anchor prices it publishes: most were
 * inferred, and the salon is the party liable for them (NN 101/2026). The
 * server decides who owes it; dismissing lasts until the next load.
 */
export function AnchorReviewBanner() {
  const navigate = useNavigate();
  const permissions = useUserPermissionsStore(
    useShallow((state) => state.permissions),
  );
  const canReview = Boolean(permissions.view_services_page);
  const { data } = api.anchorReview.useGetAnchorReviewSummary(canReview);
  const [dismissed, setDismissed] = useState(false);

  if (dismissed || !data?.requiresAnchorPrice) return null;
  if (data.unconfirmed + data.missing === 0) return null;

  return (
    <div
      className="sticky top-0 z-40 w-full"
      data-identifier="anchor-review-banner"
    >
      <LimeAlert
        color="warning"
        classNames={{ base: "rounded-none border-x-0 border-t-0" }}
        isClosable
        onClose={() => setDismissed(true)}
        title={<Trans>Potrdite cene na 10. 9. 2026</Trans>}
        description={
          <>
            <Plural
              value={data.unconfirmed}
              one="# nepotrjena cena"
              two="# nepotrjeni ceni"
              few="# nepotrjene cene"
              other="# nepotrjenih cen"
            />
            {", "}
            <Plural
              value={data.missing}
              one="# manjkajoča"
              two="# manjkajoči"
              few="# manjkajoče"
              other="# manjkajočih"
            />
          </>
        }
        endContent={
          <Button
            color="warning"
            size="sm"
            className="shrink-0"
            onPress={() => navigate("/dashboard/services/anchor-review")}
            data-identifier="anchor-review-banner-open"
          >
            <Trans>Preglej cene</Trans>
          </Button>
        }
      />
    </div>
  );
}
